<div *ngIf="html === undefined; else showHtml" class="loader" style="padding: 1em 0;">
  <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
  <div class="loader-text">
    {{ 'confluence.loading' | translate }}
  </div>
</div>

<ng-template #showHtml>
  <div #container [innerHTML]="html" style="padding: 1em 0;"></div>
</ng-template>
